import { atom } from "jotai";

export const descargasAtom = atom([]) ;
